module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-portal-4.60f7687f.svg";